import Vue from 'vue';

import {
    Area,
    Button,
    Cell,
    CellGroup,
    Checkbox,
    CheckboxGroup,
    DatetimePicker,
    Dialog,
    Divider,
    DropdownItem,
    DropdownMenu,
    Empty,
    Field,
    Form,
    Image,
    ImagePreview,
    List,
    Loading,
    Overlay,
    Picker,
    Popup,
    PullRefresh,
    Radio,
    RadioGroup,
    Search,
    Tab,
    Tabs,
    Toast,
} from 'vant';

Vue.use(Form)
    .use(Field)
    .use(Button)
    .use(List)
    .use(Search)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Popup)
    .use(Divider)
    .use(Picker)
    .use(Tabs)
    .use(Cell)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(PullRefresh)
    .use(Empty)
    .use(Toast)
    .use(Dialog)
    .use(Image)
    .use(Loading)
    .use(Overlay)
    .use(ImagePreview)
    .use(Tab)
    .use(DatetimePicker)
    .use(RadioGroup)
    .use(Radio)
    .use(Area);
